import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import PropTypes from 'prop-types';

export default function Accord({
  tasks,
  withoutGuides,
  toggleAccordion,
  saveData,
  active,
}) {
  // Expanded painel
  const handleChange = React.useCallback((value) => {
    const accordion = active === value ? false : value;

    // Checks whether the accordion will be closed and performs a callback to save typed data
    if (!accordion || active !== value) saveData();

    toggleAccordion(accordion);
  }, []);

  if (!withoutGuides)
    return (
      <>
        {tasks
          .filter((task) => !!task.slug)
          .map((task) => (
            <Accordion
              expanded={task.slug === active}
              onChange={() => handleChange(task.slug)}
              key={`accord-${task.slug}`}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`${task.slug}-content`}
                id={`${task.slug}-header`}
              >
                <Typography style={{ textTransform: 'uppercase' }}>
                  {task.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {task.component({ saveData })}
              </AccordionDetails>
            </Accordion>
          ))}
      </>
    );

  return tasks[0].component({ saveData });
}

Accord.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.any).isRequired,
  withoutGuides: PropTypes.bool,
  toggleAccordion: PropTypes.func.isRequired,
  saveData: PropTypes.func.isRequired,
  active: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

Accord.defaultProps = {
  withoutGuides: false,
};
